import { render, staticRenderFns } from "./Cashpower.vue?vue&type=template&id=389f4fa5&scoped=true"
import script from "./Cashpower.vue?vue&type=script&lang=js"
export * from "./Cashpower.vue?vue&type=script&lang=js"
import style0 from "./Cashpower.vue?vue&type=style&index=0&id=389f4fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f4fa5",
  null
  
)

export default component.exports